var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.5 6.24988L0 6.24988","stroke":"#FCB34E","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M6.25 -0.00012207L6.25 12.4999","stroke":"#FCB34E","strokeWidth":"2","key":1})]);
}

Plus.defaultProps = {"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none"};

module.exports = Plus;

Plus.default = Plus;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/icons/plus.svg
// module id = 668
// module chunks = 0